export default function Logo({ size = 32, showWordmark = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Serif C mark */}
        <path
          d="M42 20.5c-2.6-2.4-6-3.8-9.7-3.8-8.2 0-14.8 6.8-14.8 15.3S24.1 47.3 32.3 47.3c3.7 0 7.1-1.4 9.7-3.8"
          stroke="currentColor"
          strokeWidth="3.3"
          strokeLinecap="square"
          fill="none"
        />
        {/* Chisel edge accent */}
        <path d="M44 15L48 22L44 22Z" fill="currentColor" />
        {/* Baseline */}
        <path d="M14 52H50" stroke="currentColor" strokeWidth="1.2" />
      </svg>
      {showWordmark && (
        <span className="font-display text-xl sm:text-2xl tracking-tight leading-none">
          C—Carpenter
        </span>
      )}
    </div>
  );
}
